<div class="schedule-message-modal">
    <div class="modal-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0 fw-bold">Schedule your message</h5>
        <button type="button" 
                class="btn-close" 
                (click)="cancel()"
                aria-label="Close">
            <img src="assets/common/ic_x_s_size.svg" alt="Close" />
        </button>
    </div>
    
    <form #scheduleForm="ngForm" (ngSubmit)="schedule()">
        <div class="modal-body">
            <div class="schedule-section">
                <h5 class="section-title">Select date & time</h5>
                <p class="section-description">Schedule the message for a specific date and time.</p>
                
                <div class="date-time-inputs">
                    <div class="date-input-wrapper">
                        <img src="assets/common/ic_calendar_s_size.svg" alt="Date" />
                        <input type="text"
                               class="form-control date-input"
                               placeholder="Pick a date"
                               name="selectedDate"
                               required
                               [(ngModel)]="selectedDate"
                               [bsConfig]="{ dateInputFormat: 'MMM DD, YYYY' }"
                               bsDatepicker
                               [minDate]="minDate"
                               placement="bottom"
                               autocomplete="off">
                    </div>
                    
                    <div class="time-input-wrapper">
                        <img src="assets/common/ic_clock_s_size.svg" alt="Time" />
                        <ng-select name="selectedTime"
                                   class="time-select"
                                   required
                                   [clearable]="false"
                                   [items]="timeOptions"
                                   bindLabel="label"
                                   bindValue="value"
                                   placeholder="Select time"
                                   [(ngModel)]="selectedTime">
                        </ng-select>
                    </div>
                </div>
                
                <div class="timezone-info">
                    <i class="ti ti-info-circle"></i>
                    <span>{{ getTimezoneInfo() }}</span>
                </div>
            </div>
        </div>
        
        <div class="modal-footer">
            <button type="button"
                    class="btn btn-outline-secondary"
                    (click)="cancel()">
                Cancel
            </button>
            <button type="submit"
                    class="btn btn-primary"
                    [disabled]="!selectedDate || !selectedTime">
                Schedule message
            </button>
        </div>
    </form>
</div>
